<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
        <header class="bandeau-modal card-header">
        </header>
        <div class="card-content" v-if="lieuDeLivraison">
          <p class="title has-text-centered mgb-20px">
            {{ $t('addEditOrdreTravailTech.lieuDeLivraison.informations.addLieuDeLivraison')}}
          </p>
          <error-msg-component :messages="messagesErreur"
            :error="error"
            :messagesChampsVide="messagesChampsVide"
            :champsVide="champsVide"
            :title="'general.problemOccurred'"
            @close="error = $event"/>
          <b-field
            :label="$t('addEditOrdreTravailTech.lieuDeLivraison.informations.commercialName')"
            :type="typeNomCommercial"
            class="obligatoire">
            <b-input v-model="lieuDeLivraison.nomCommercial"></b-input>
          </b-field>
          <p class="mgt-20px is-italic has-text-icon-more is-size-5">
            {{$t('addEditOrdreTravailTech.lieuDeLivraison.informations.address')}}
          </p>
          <b-field :label="$t('addEditOrdreTravailTech.lieuDeLivraison.informations.postalAddress')"
             v-if="lieuDeLivraison.adressePostale">
            <app-adresse :showLibelle="false" :adresse="lieuDeLivraison.adressePostale"
                            :tableName="TIERS"/>
          </b-field>
          <b-field class="mgt-10px">
            <div class="is-pulled-left boutonAction">
                <a class="button" @click="$parent.close">
                {{ $t('addEditOrdreTravailTech.lieuDeLivraison.actions.revert')}}
                </a>
            </div>
            <div class="is-pulled-left boutonAction">
                <a class="button is-addOrEdit" @click="creerLieuDeLivraison()">
                {{ $t('addEditOrdreTravailTech.lieuDeLivraison.actions.add')}}
                </a>
            </div>
          </b-field>
        </div>
    </div>
  </div>
</template>

<script>
import errorMsgComponent from '@/components/general/errorMsgComponent';
import gestionType from '@/services/general/gestionType';
import { TIERS } from '@/configuration/ville/villeConf';
import AppAdresse from '@/components/general/adresse';
import validationGeneral from '@/services/validation/validation';
import champsTiersTranslator from '@/services/tiers/champsTiersTranslator';
import { insertTiers } from '@/services/tiers/saveTiers';
import messageSucces from '@/services/general/messageSucces';
import generer from '@/services/tiers/genererLieuDeLivraison';
import { createNamespacedHelpers } from 'vuex';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    nomLieuDeLivraison: {
      type: String,
      required: true,
    },
  },
  components: {
    errorMsgComponent,
    AppAdresse,
  },
  data() {
    return {
      messagesErreur: [],
      champsVide: [],
      messagesChampsVide: [],
      lieuDeLivraison: {},
      TIERS,
      error: false,
    };
  },
  methods: {
    async creerLieuDeLivraison() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messagesErreur = [];
        this.messagesChampsVide = [];
        this.champsVide = [];
        this.lieuDeLivraison = await insertTiers(this.lieuDeLivraison);
        this.$emit('select', this.lieuDeLivraison);
        this.$parent.close();
        messageSucces(this.$i18n.t('addEditOrdreTravailTech.messages.successLieuDeLivraisonCreation'));
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messagesErreur, this.messagesChampsVide, champsTiersTranslator);
          this.error = true;
        }
      } finally {
        loadingComponent.close();
      }
    },
  },
  computed: {
    typeNomCommercial() {
      return gestionType(this.lieuDeLivraison.nomCommercial, this.error);
    },
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  mounted() {
    this.lieuDeLivraison = generer(this.nomLieuDeLivraison, this.societeActiveId);
  },
};
</script>
